<template>
    
    <div id="secondary-navigation" :class="brightness">
        
        <div class="hit-area" ref="hitArea" @click="onClickNavigation">
            <div class="label">
                <p :class="{'link': (hasLink === true)}">
                    {{text}}
                </p>
            </div>
            
            <div class="close-btn" v-if="showCloseIcon">
                <span class="bar-1"></span>
                <span class="bar-2"></span>
            </div>
        </div>
    </div>
    
</template>


<script>

export default {
    
    props: {
        text: {
            type: String,
            default: 'Missing label text',
            required: true,
        },
        hasLink: {
            type: Boolean,
            default: false,
        },
        brightness: {
            type: String,
            default: 'dark',
        },
        showCloseIcon: {
            type: Boolean,
            default: false,
        },
        
    },
    
    // data: function() {
    //     return {}
    // },

    mounted() {
    },
    
    methods: {
        onClickNavigation() {
            // Dispatch event
            if (this.hasLink === true) {
                // console.log('emit: ', this.link);
                this.$emit('clicked', event.target)
            }
        },
    },
    
    // computed: {
    //     hasLink() {
    //         return (this.link === '') ? false : true
    //     },
    // },
    
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';
@import '../scss/font-scaling';

#secondary-navigation {
    position: fixed;
    top: 36px;
    right: 6%;
    width: calc(50% - 6%);
    
    
    @media (min-width: $tablet) {
        width: 94px;
        top: 0;
        height: 100%;
        right: 0;
    }
    
    &.dark {
        color: #000;
        .bar-1,
        .bar-2 {
            background-color: #000;
        }
    }
    
    &.light {
        color: #fff;
        .close-btn {
            .bar-1,
            .bar-2 {
                background-color: #fff;
            }
        }
    }
    
    .hit-area {
        position: absolute;
        left: 0;
        right: 0;
        
        @media (min-width: $tablet) {
            top: 25px;
            left: 20px;
            right: 20px;
            bottom: 25px;
        }
        
        &:hover {
            cursor: pointer;
            .link {
                text-decoration: line-through;
            }
            .close-btn {
                .bar-1,
                .bar-2 {
                    opacity: 0.7
                }
            }
        }    
        
        .label {
            position: absolute;
            width: 100%;
            text-align: right;
            line-height: 0;
            
            @media (min-width: $tablet) {
                top: 50%;
                left: 50%;
                width: 100vh;
                transform: translate(-50%, -50%) rotate(90deg);
                text-align: center; 
            }
            
            
            p {
                display: inline;
                font-size: 11px;
                color: inherit;
                text-transform: uppercase;
                line-height: 1em;
                
                @media (min-width: $tablet) {
                    @include FluidFontStart(1024, 1600, 12, 16);
                    @include FluidFontEndless(1600, 16, .4);
                }
                
                &.link {
                    cursor: pointer;
                }
            }
        }
        
        .close-btn {
            display: none;
            
            @media (min-width: $tablet) {
                display: block;
                position: absolute;
                // Hit area: 25px 20px 25px 20px
                top: calc(15px - 4px); // 4px Optical adjustment 
                right: calc((94px - 40px)/2); // Hit-area: 20px + 20px = 40px
                width: 20px;
                height: 20px;
                transform: translateX(50%);
                cursor: pointer;
            }
            
            .bar-1,
            .bar-2 {
                position: absolute;
                height: 1px;
                left: 0;
                width: 100%;
                top: 50%;
            }
            
            .bar-1 {
                transform: rotate(45deg);
            }
            .bar-2 {
                transform: rotate(-45deg);
            }
        }
    }
}
</style>
